import { useLoginModal } from '@/contexts/LoginModalContext';
import { curStateAccount } from '@/Redux/selector';
import { hasAuthCookie } from '@/utils/auth';
import { useSelector } from 'react-redux';

export default function ButtonTab3({ activeT, setActiveT, tabsT = [] }) {
	const { openLogin } = useLoginModal();
	const account = useSelector(curStateAccount);

	const isAuthed = hasAuthCookie() || Boolean(account?.userInfo) || Boolean(account?.token);

	const handleTabClick = (index) => {
		// Nếu chọn tab index 1 mà chưa login -> show popup login, không đổi tab
		if (index === 1 && !isAuthed) {
			openLogin();
			return;
		}
		setActiveT(index);
	};

	return (
		<div className="flex relative border-b-2 border-[#F9DBAF] 
									mb-5
									">
			{tabsT.map((tab, index) => (
				<button
					key={tab}
					onClick={() => handleTabClick(index)}
					className={`
												relative
												flex-1
												h-[54px]
												cursor-pointer
												font-bold
												text-[27px]
												transition-all
												outline-none
													${activeT === index
							? "text-[#713B12]"
							: "text-[#713B12]"
						}
												`}
				>
					{tab}
					{activeT === index && (
						<span
							className="
													absolute
													left-0
													right-0
													-bottom-[2px]
													h-[4px]
													rounded-full
													bg-[#EF6820]
													z-10
												"
						/>
					)}
				</button>
			))}
		</div>
	)
}
